import React from 'react'
import PropTypes from 'prop-types'

import Header from './components/header'

import * as styles from './styles'

const LayoutComponent = ({ children, isHeaderFooterHidden }) => (
  <div css={styles.container}>
    {!isHeaderFooterHidden && <Header />}
    <div
      css={[
        styles.contentContainer,
        isHeaderFooterHidden
          ? {
              minHeight: '100%',
            }
          : {},
      ]}
    >
      <div id="main-content" css={!isHeaderFooterHidden ? styles.content : {}}>
        {children}
      </div>
    </div>
  </div>
)

LayoutComponent.propTypes = {
  children: PropTypes.node.isRequired,
  isHeaderFooterHidden: PropTypes.bool,
}

export default LayoutComponent
